import { BookmarkablePage, DetailView, DetailViewsPanel, GroupItem, useNavigation } from "o4a-react";
import * as React from "react";
import { useParams } from "react-router-dom";
import * as Messages from "../../codegen/Messages";
import { ConsoleContext } from "../../console/ConsoleContext";
import { ADB_LIST_HUB_ROUTE, DetailsPanelId, PageId, PageRegistrationConfig } from "../../constants/pluginConstants";
import { AdbsList } from "../AdbsListPage/AdbsList";

const registrationIds = PageRegistrationConfig[PageId.ADB_LIST_HUB].map(config => config.key);

const getViewId = (panelId: string | undefined): string => {
  switch (panelId) {
    case DetailsPanelId.ADBS_DATABASES:
    default:
      return registrationIds[0];
  }
};

const getIconName = (panelId: string | undefined): string => {
  switch (panelId) {
    case DetailsPanelId.ADBS_DATABASES:
    default:
      return "adb-svg";
  }
};

export const AdbListHubPage = (): JSX.Element => {
  const { listId } = useParams();

  const { back, navigateToSelf, navigateToPanel } = useNavigation(ConsoleContext);

  React.useEffect(() => {
    // In case page was navigated to directly by entring its URL in the browser
    const registrationConfig = PageRegistrationConfig[PageId.ADB_LIST_HUB].find(
      config => config.panelPath === listId,
    );
    const path = `${ADB_LIST_HUB_ROUTE}/${listId}`;
    navigateToSelf(path, registrationConfig?.key || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onMenuItemSelect = (id: string): void => navigateToPanel(id);

  const detailViews: DetailView[] = [
    {
      id: registrationIds[0],
      content: (<AdbsList />),
    },
  ];

  const groupItems: GroupItem[] = [
    {
      heading: Messages.labels.shared(),
      items: [
        { icon: getIconName(DetailsPanelId.ADBS_DATABASES), id: detailViews[0].id, name: Messages.labels.databases() },
      ],
    },
  ];

  const getTitlePrefix = (panelId: string | undefined): string => {
    switch (panelId) {
      case DetailsPanelId.ADBS_DATABASES:
      default:
        return Messages.serviceProviders.adbShared();
    }
  };

  const getTitleSuffix = (panelId: string | undefined): string => {
    switch (panelId) {
      case DetailsPanelId.ADBS_DATABASES:
      default:
        return Messages.labels.databases();
    }
  };

  const getTitle = (
    panelId: string | undefined,
  ): string => `${getTitlePrefix(panelId)} | ${getTitleSuffix(panelId)}`;

  return (
    <BookmarkablePage
      appContext={ConsoleContext}
      registrationIds={registrationIds}
      title={getTitlePrefix(listId)}
      titleSuffix={getTitleSuffix(listId)}
    >
      <DetailViewsPanel
        anchorId="page"
        title={getTitle(listId)}
        icon={getIconName(listId)}
        onClose={back}
        isOpen
        views={detailViews}
        activeViewId={getViewId(listId)}
        onMenuItemSelect={onMenuItemSelect}
        menu={groupItems}
      />
    </BookmarkablePage>
  );
};
